import * as React from 'react';
const Marker = (props) => {
    return (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", width: 24, height: 32, style: {
            position: 'absolute',
            zIndex: 999,
            ...props.style,
        } },
        React.createElement("mask", { id: `prefix__marker_0`, maskUnits: "userSpaceOnUse", x: 6, y: 4 },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.29 16.675c.591.842 1.284 1.828 2.093 3.002a.75.75 0 001.234 0c.81-1.174 1.502-2.16 2.092-3.002C17.431 12.799 18 11.988 18 10a6 6 0 10-12 0c0 1.988.569 2.798 3.29 6.675zM14.5 10a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z", fill: "#fff" })),
        React.createElement("g", { mask: `url(#prefix__marker_0)` },
            React.createElement("path", { fill: props.color, d: "M0 0h24v24H0z" }))));
};
export default Marker;
